import type { PortalStorefrontItemCardDto } from '@supply-mover-2-0/shared';
import {
	StorefrontItemCard as SharedStorefrontItemCard,
	StorefrontItemPrice as SharedStorefrontItemPrice,
} from '@supply-mover-2-0/web-ui';
import type { ComponentProps, JSX } from 'react';
import { useDisplaySettings } from '../../../hooks/useDisplaySettings';
import { AddToCartControl } from '../../AddToCartControl';

/**
 * The storefront's item card: the shared card (libs/web-ui, also drawn by the
 * CRM page builder) with the storefront's own add-to-cart control, and prices
 * shown only when this visitor may see catalog pricing (PD-14239, PD-14775).
 */
export function StorefrontItemCard({
	item,
	onNavigate,
	onLikelyStaleUrl,
}: {
	item: PortalStorefrontItemCardDto;
	onNavigate: () => void;
	onLikelyStaleUrl?: () => void;
}): JSX.Element {
	const displaySettings = useDisplaySettings();
	return (
		<SharedStorefrontItemCard
			item={item}
			onNavigate={onNavigate}
			onLikelyStaleUrl={onLikelyStaleUrl}
			showPrice={displaySettings.canSeeCatalogPricing}
			actions={<StorefrontCardCartControl item={item} />}
		/>
	);
}

/** The floating add-to-cart control every storefront item card carries. */
export function StorefrontCardCartControl({
	item,
}: {
	item: PortalStorefrontItemCardDto;
}): JSX.Element {
	return (
		<AddToCartControl
			itemId={item.id}
			variant="floating"
			inStock={item.inStock}
			deaSchedule={item.deaSchedule}
		/>
	);
}

/** Price block, hidden when this visitor may not see catalog pricing. */
export function StorefrontItemPrice(
	props: ComponentProps<typeof SharedStorefrontItemPrice>,
): JSX.Element {
	const displaySettings = useDisplaySettings();
	if (!displaySettings.canSeeCatalogPricing) {
		return <></>;
	}
	return <SharedStorefrontItemPrice {...props} />;
}
